<template>
  <v-container class="baader-container">
    <h1>Baader Transactions</h1>
    <br>

    <v-card>
      <v-card-title class="card-title">
        <span class="headline white--text text-uppercase">WUM</span>
      </v-card-title>

      <v-card-text class="px-0 py-0">
        <wum-transactions-component
          v-if="isWUM"
          :securities="wumSecurities"
        />

        <div
          v-else
          class="load-wrapper"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
      </v-card-text>
    </v-card>

    <v-expansion-panel v-model="panelIndex">
      <v-expansion-panel-content>
        <div
          slot="header"
          title
        >
          <h3
            slot="header"
            class="title"
          >
            RKK
          </h3>
        </div>

        <v-card v-if="isRKK">
          <v-card-text class="px-0 py-0">
            <rkk-transactions-component
              :securities="rkkSecurities"
            />
          </v-card-text>
        </v-card>
        <div
          v-else
          class="load-wrapper"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { WUMTransactionsComponent, RKKTransactionsComponent } from '@/components/baader';

export default {
  name: 'BaaderDetail',
  components: {
    'wum-transactions-component': WUMTransactionsComponent,
    'rkk-transactions-component': RKKTransactionsComponent,
  },
  data() {
    return {
      isWUM: false,
      isRKK: false,
      rkkSecurities: [],
      wumSecurities: [],
      panelIndex: -1,
    };
  },
  watch: {
    panelIndex() {
      if (this.panelIndex === 0) {
        this.isRKK = false;
        this.rkkSecurities = [];

        this.getRKKSecuritiesBySNR(this.$route.params.snr).then((securities) => {
          if (Array.isArray(securities)) {
            this.rkkSecurities = securities;
          } else {
            this.rkkSecurities = [];
          }

          this.isRKK = true;
        }).catch(() => {
          this.rkkSecurities = [];
          this.isRKK = true;
        });
      }
    },
  },
  mounted() {
    this.getWumSecuritiesBySNR(this.$route.params.snr).then((securities) => {
      if (Array.isArray(securities)) {
        this.wumSecurities = securities;
      } else {
        this.wumSecurities = [];
      }

      this.isWUM = true;
    }).catch(() => {
      this.wumSecurities = [];
      this.isWUM = true;
    });
  },
  methods: {
    ...mapActions([
      'getWumSecuritiesBySNR',
      'getRKKSecuritiesBySNR',
    ]),
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 24px !important;
}
.load-wrapper {
  display: flex;
  justify-content: center;
  height: 80px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/baader/BaaderDetail.vue